var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "3" } }, [_c("Menu")], 1),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "border", attrs: { cols: "9" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "head",
                                      attrs: { cols: "12" }
                                    },
                                    [_c("h4", [_vm._v(":: Marcas")])]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "breadcrumb",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c(
                                        "b-link",
                                        {
                                          attrs: { to: { name: "BrandList" } }
                                        },
                                        [_vm._v("Marcas")]
                                      ),
                                      _vm._v(" » "),
                                      _c(
                                        "b-link",
                                        {
                                          attrs: {
                                            href:
                                              "/brands/brand/" +
                                              this.$route.params.id
                                          }
                                        },
                                        [_vm._v(_vm._s(this.brand.name))]
                                      ),
                                      _vm._v(" » Editar:\n                    ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-2" }),
                              _vm._v(" "),
                              _c(
                                "b-form",
                                {
                                  staticClass: "pb-4",
                                  on: { submit: _vm.onSubmit }
                                },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "fieldsetHorizontal",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Nombre"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { id: "name", state: _vm.state },
                                        model: {
                                          value: _vm.brand.name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.brand,
                                              "name",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "brand.name"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "fieldsetHorizontal",
                                        horizontal: "",
                                        "label-cols": 4,
                                        breakpoint: "md",
                                        label: "Slug"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { id: "slug", state: _vm.state },
                                        model: {
                                          value: _vm.brand.slug,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.brand,
                                              "slug",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "brand.slug"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        variant: "primary derco"
                                      }
                                    },
                                    [_vm._v("Actualizar")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a29f5c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a29f5c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditBrand.vue
// module id = null
// module chunks = 